import fetch from "../auth/FetchInterceptor";

const Services = {};

Services.fetchData = async (url) => {
  const response = await fetch(url);
  return response;
};

Services.updateData = async ({ url, data = {}, params = {} }) => {
  try {
    const response = await fetch.put(url, data, { ...params });
    return response;
  } catch (err) {
    const error = err;
    // console.log(error);
    return;
  }
};

export default Services;
